module.exports = __webpack_public_path__ + "static/media/hancock.b15de68d.jpeg";